import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/tetris-optimilk-params'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  update: NoParamEndpointConstructor
}

export const tetrisDefaultPricesEndpoints: Endpoints = {
  getAll: () => baseUrl,
  update: () => baseUrl,
}
